<script setup lang="ts"></script>

<template>
    <div
        class="w-full h-fit overflow-y-auto rounded-[2rem] bg-white p-[2.4rem] text-base shadow-lg pointer-events-auto"
    >
        <div class="size-full sm:max-h-[80rem]">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss" scoped></style>
